<template>
  <div id="contenedor-main-listado-superintendentes">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoSuperintendentes="listadoSuperintendentes"></desktop>
    </template>
    <template v-else>
      <mobile :listadoSuperintendentes="listadoSuperintendentes"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoSuperintendentes',
  props: {
    listadoSuperintendentes: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
